var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PartnerPage',{attrs:{"greeting":false,"title":"Users & Access","doc":_vm.doc},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('CreatePerson')]},proxy:true}])},[_c('List',{staticClass:"my-3",attrs:{"items":_vm.items}}),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }